import { Text, WarningIcon } from '@buffer-mono/popcorn'

/**
 *
 */
const ErrorMessage = ({ message }: { message: string }): JSX.Element => {
  return (
    <Text as="p" color="warning" icon={<WarningIcon />}>
      {message}
    </Text>
  )
}

export { ErrorMessage }
